import memoize from 'lodash/memoize';

import get from 'lodash/get';

export default memoize((data: unknown): number => {
  return get(data, 'total', 0);
});
